var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronIcon = function SvgChevronIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.705 13.28a1.006 1.006 0 0 1 0 1.425 1.01 1.01 0 0 1-1.427 0L12 10.432l-4.278 4.273a1.01 1.01 0 0 1-1.427 0 1.006 1.006 0 0 1 0-1.424l4.992-4.986a1.01 1.01 0 0 1 1.426 0l4.992 4.986Z"
  })));
};
export default SvgChevronIcon;